/**
 * @file src/components/knowledge/iconMap.ts
 * @description Maps string identifiers to Heroicon components for client-side rendering.
 * This approach is necessary to avoid passing non-plain objects (React components)
 * from Server Components to Client Components, which is not allowed in Next.js.
 */

import {
  ForwardRefExoticComponent,
  PropsWithoutRef,
  RefAttributes,
  SVGProps,
} from "react"
import {
  ArrowPathIcon,
  ArrowsRightLeftIcon,
  ChartBarIcon,
  CircleStackIcon,
  CpuChipIcon,
  EyeIcon,
  MapIcon,
  PuzzlePieceIcon,
  RocketLaunchIcon,
  ShieldCheckIcon,
  WrenchScrewdriverIcon,
} from "@heroicons/react/24/outline"

export type HeroIcon = ForwardRefExoticComponent<
  PropsWithoutRef<SVGProps<SVGSVGElement>> & {
    title?: string
    titleId?: string
  } & RefAttributes<SVGSVGElement>
>

export const iconMap: Record<string, HeroIcon> = {
  MapIcon,
  EyeIcon,
  CircleStackIcon,
  ChartBarIcon,
  WrenchScrewdriverIcon,
  PuzzlePieceIcon,
  ArrowsRightLeftIcon,
  CpuChipIcon,
  RocketLaunchIcon,
  ShieldCheckIcon,
  ArrowPathIcon,
}
